import { getWorkshopListById } from "./enrollmentApi";

const host = window.location.hostname;

export const API_HOST = (host === "localhost" || host.includes("local.opentide.com.cn"))
  ? "https://hkclubs.local.opentide.com.cn/"
  : "https://hkclubs.samsung.com/";

export const baseURL = {
  //enquiry
  getEnrollmentList: "/ClubsAPI/api/CRMWorkshop/GetEnrollmentList",
  getWorkshopListById: "/ClubsAPI/api/CRMWorkshop/GetWorkShopListById",
  getWorkshopListByWorkshopId: "/ClubsAPI/api/CRMWorkshop/GetWorkShopListByWorkshopId",
  modifyWorkshopEnrollment:
    "/ClubsAPI/api/CRMWorkshop/ModifyWorkShopEnrollment",
  cancelWorkshopEnrollment:
    "/ClubsAPI/api/CRMWorkshop/CancelWorkShopEnrollment",

  //landing page
  getLandingKV: "/ClubsAPI/api/Landing/GetLandingKv",
  getEventList: "/ClubsAPI/api/Landing/GetEventList",
  getVideoList: "/ClubsAPI/api/Landing/GetVideoList",
  getBlogList: "/ClubsAPI/api/Landing/GetBlogList",
  getRelateVideoList: "/ClubsAPI/api/Landing/GetRelatedVideoList",
  getRelateBlogList: "/ClubsAPI/api/Landing/GetRelatedBlogList",
  getBlogById: "/ClubsAPI/api/Landing/GetBlogById",
  addClickRate: "/ClubsAPI/api/Landing/AddArticleView",
  addArticleLike: "/ClubsAPI/api/Landing/AddArticleLike",

  //event form page
  getWorkShopList: "/ClubsAPI/api/CRMWorkshop/GetWorkShopList",
  checkDuplcateSubmission: "/ClubsAPI/api/CRMWorkshop/CheckDuplcateSubmission",
  submitEventForm: "/ClubsAPI/api/CRMWorkshop/WorkShopEnrollment",
  checkWorkShopAccessCode: "/ClubsAPI/api/CRMWorkshop/CheckAccessCode",
  getAccessCodeWorkShopList: "/ClubsAPI/api/CRMWorkshop/GetAccessCodeWorkshopList",
  getWorkshopVideoList: "/ClubsAPI/api/CRMWorkshop/GetCRMWorkshopVideo",
  submitWorkshopVideoAnswer: "/ClubsAPI/api/CRMWorkshop/CRMWorkshopVideoAnswer",

  //authentication login
  loginAccess: "/ClubsAPI/api/Login/ClubsLoginAccess",
  getLinkedSA: "/ClubsAPI/api/Login/GetLinkedSA",
  clubsLoginOTP: "/ClubsAPI/api/Login/ClubsLoginOTP",
  sendOTPCode: "/ClubsAPI/api/OTPValidation/SendOTPCode",
  verificationOTP: "/ClubsAPI/api/OTPValidation/OTPVerification",
  forgetPassword: "/ClubsAPI/api/Login/ForgetPassword",
  resetPassword: "/ClubsAPI/api/Login/ResetPassword",

  //Member zone
  getMemberProfile: "/ClubsAPI/api/Member/GetMemberProfile",
  editMemberProfile: "/ClubsAPI/api/Member/EditMemberProfile",
  getRegisteredProduct: "/ClubsAPI/api/Member/GetRegisteredProduct",
  getRedeemHistory: "/ClubsAPI/api/Member/GetRedeemHistory",
  getPointHistory: "/ClubsAPI/api/Member/GetPointHistory",

  //earn s dollar
  productRegistration: "/ClubsAPI/api/Product/Registration",

  //Redeem
  getOfferList: "/ClubsAPI/api/RedeemOffer/GetOfferList",
  getOfferDetail: "/ClubsAPI/api/RedeemOffer/GetOfferDetail",
  submitRedeemOffer: "/ClubsAPI/api/RedeemOffer/RedeemOffer",
  submitConvertRewards: "/ClubsAPI/api/RedeemOffer/ConvertRewards",

  //common
  getChannel: "/ClubsAPI/api/Location/GetChannel",
  getLocationByType: "/ClubsAPI/api/Location/GetLocationByType",
  getOptionData: "/ClubsAPI/api/Option/GetOptionData",
  updatePopupCount: "/ClubsAPI/api/Member/UpdatePopupCount",

};
